export default "__VITE_ASSET__BT$K9C3h__"